/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-02-02 11:42:39
 * @LastEditTime: 2024-03-08 11:04:19
 * @Descripttion: file content
 */
export const BASE_URL = '//www.efceping.cn'
const BASE_URL_UC = BASE_URL + '/uc'
const BASE_URL_TEA = BASE_URL + '/tea'
const BASE_URL_PC = BASE_URL + '/pc'

export const PC_API = {
	login: BASE_URL_PC + '/publish/login',
	logout: BASE_URL_PC + '/publish/logout',
	getAppConfModule: BASE_URL_PC + '/publish/getPublishType',
	getCheckList: BASE_URL_PC + '/publish/racelist',
	getCollectionList: BASE_URL_PC + '/publish/getpaperset',
	getExamList: BASE_URL_PC + '/publish/getpaperlist',
	getPaperDetail: BASE_URL_PC + '/publish/getpapercontent',
	getAreaList: BASE_URL_PC + '/area/getList',
	getSchoolList: BASE_URL_PC + '/publish/getSchoolList',
	getClassList: BASE_URL_PC + '/publish/getSchoolStu',
	savePublishStu: BASE_URL_PC + '/publish/savePublishStu',
	getDefaultName: BASE_URL_PC + '/race/getDefaultName',
	publishMentor: BASE_URL_PC + '/publish/createRace',
	getAnalysis: BASE_URL_PC + '/race/getAnalysis',
	getCompletion: BASE_URL_PC + '/race/getCompletion',
	publishUser: BASE_URL_PC + '/race/publishUser',
	delRace: BASE_URL_PC + '/race/delRace',
	getPaperReport: BASE_URL_PC + '/race/getPaperReport',
	getRaceContent: BASE_URL_PC + '/publish/getRaceContent',
	exportUser: BASE_URL_PC + '/race/exportUser',
	getLoginInfo: BASE_URL_PC + '/publish/getLoginInfo'
}

export const UC_API = {
	getArea: BASE_URL_UC + '/area',
	getSchoolList: BASE_URL_UC + '/school/getSchools',
	sendCode: BASE_URL_UC + '/sms/sendCode',
	login: BASE_URL_UC + '/session/login',
	resetPwd: BASE_URL_UC + '/account/resetpwd'
}

export const TEA_API = {
	getTeacherInfo: BASE_URL_TEA + '/teacher/getTeacherInfo',
	getAppConfModule: BASE_URL_TEA + '/appConfig/module',
	getCheckList: BASE_URL_TEA + '/home/checkList',
	getGrades: BASE_URL_TEA + '/category/grades',
	getUnits: BASE_URL_TEA + '/category/getUnits',
	getCategoryBooks: BASE_URL_TEA + '/category/books',
	getQuesDetails: BASE_URL_TEA + '/ques/getQuesDetails',
	getTargetUser: BASE_URL_TEA + '/teacher/getTargetUser',
	getMentorDefaultName: BASE_URL_TEA + '/mentor/getDefaultName',
	getPcexamDefaultName: BASE_URL_TEA + '/pcexam/getDefaultName',
	publishMentor: BASE_URL_TEA + '/mentor/publish',
	getPraCheckL: BASE_URL_TEA + '/mentor/getExamineList',
	getExamCheckL: BASE_URL_TEA + '/pcexam/getExamList',
	getPapertype: BASE_URL_TEA + '/examcollection/getpapertype',
	getCollectionList: BASE_URL_TEA + '/examcollection/getCollectionList',
	getPaperDetail: BASE_URL_TEA + '/paper/getPaperDetail',
	getMentorPublishedDetail: BASE_URL_TEA + '/mentor/getPublishedDetail',
	getPcExamPublishedDetail: BASE_URL_TEA + '/pcexam/getPublishedDetail',
	getPhonetics: BASE_URL_TEA + '/phonetic/phonetics',
	getDubbGrades: BASE_URL_TEA + '/dubb/grades',
	getDubbCategories: BASE_URL_TEA + '/dubb/categories',
	getDubbing: BASE_URL_TEA + '/dubb',
	getPaperType: BASE_URL_TEA + '/examcollection/getpapertype',
	getQuesList: BASE_URL_TEA + '/special/getQuesList',
	getExamList: BASE_URL_TEA + '/paper/getExamList',
	getCLassList: BASE_URL_TEA + '/mentor/getClasses',
	getContentInfo: BASE_URL_TEA + '/mentor/getContentInfo',
	getCopyStudent: BASE_URL_TEA + '/mentor/getcopystudent',
	hurry: BASE_URL_TEA + '/mentor/hurry',
	deleteHomework: BASE_URL_TEA + '/mentor/deleteHomework',
	receiveHomework: BASE_URL_TEA + '/mentor/receiveHomework',
	getHomeworkDetail: BASE_URL_TEA + '/mentor/getExamScore',
	getPersonScore: BASE_URL_TEA + '/mentor/getStuResultsSum',
	getPersonTopic: BASE_URL_TEA + '/mentor/getStuResults',
	backHomework: BASE_URL_TEA + '/mentor/backHomework'
}
